import { Collapse, Box, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material';
import React, { ReactElement } from 'react';
import { formatNumber } from '../../common/Extensions';
import { DimensionTypeSR, GoodsStatusSR, DimensionTypeDimensionSR } from '../../common/Types';
import { GoodsTableBasicInfo, getColorForGoodsStatus } from './GoodsHelper';
import { DimensionType } from '../../api/ClientApi';

type GoodsTableCollapsibleBasicInfoProps = {
    isCollapsed: boolean;
    dimensionType?: DimensionType;
    goodsBasicInfo?: GoodsTableBasicInfo[];
    isSiteTable?: boolean;
};

export default function GoodsTableCollapsibleBasicInfo(props: GoodsTableCollapsibleBasicInfoProps): ReactElement {
    const { isCollapsed, dimensionType, goodsBasicInfo, isSiteTable } = props;
    return (
        <Collapse in={!isCollapsed} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Status</TableCell>
                            {!isSiteTable && <TableCell align="center">Skladište</TableCell>}
                            <TableCell align="center">
                                {dimensionType ? DimensionTypeSR[dimensionType] : 'Količina'}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {goodsBasicInfo?.map((gi) => (
                            <TableRow key={(gi.goodsStatus ? gi.goodsStatus.toString() : '/') + Math.random()}>
                                <TableCell align="center">
                                    {gi.isReserved ? (
                                        <Chip variant="outlined" label={'Rezervisano'} color="default" />
                                    ) : gi.goodsStatus ? (
                                        <Chip
                                            variant="outlined"
                                            label={GoodsStatusSR[gi.goodsStatus]}
                                            color={getColorForGoodsStatus(gi.goodsStatus)}
                                        />
                                    ) : (
                                        '/'
                                    )}
                                </TableCell>
                                {!isSiteTable && <TableCell align="center">{gi.siteName ?? '/'}</TableCell>}
                                <TableCell align="center">
                                    {gi.goodsQuantity ? formatNumber(gi.goodsQuantity) : '/'}{' '}
                                    {dimensionType ? DimensionTypeDimensionSR[dimensionType] : 'kom.'}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Collapse>
    );
}
